import React from 'react'

export const WelcomeIcon = () => (
  <svg
    width="32"
    height="38"
    viewBox="0 0 32 38"
    xmlns="http://www.w3.org/2000/svg"
    fill="#96A4B8"
  >
    <path d="M31.1222 14.7266C31.7085 12.6217 30.4343 10.426 28.278 9.82535C28.0124 9.75136 27.7383 9.70788 27.4755 9.684L27.7092 8.84511C28.2955 6.74023 27.0213 4.54448 24.865 3.94387C24.5056 3.84377 24.1335 3.78943 23.7799 3.78955C23.5968 2.21001 22.4709 0.811634 20.8147 0.350299C18.8928 -0.185025 16.9209 0.72854 16.0957 2.42171C15.847 2.28671 15.5743 2.17787 15.2774 2.09517C13.1211 1.49457 10.8952 2.71542 10.309 4.8203L7.80662 13.8041C7.40707 13.1833 6.84852 12.6497 6.18074 12.2665L5.06681 11.6111C3.86762 10.899 2.37227 11.0085 1.29225 11.9239C0.456325 12.6279 0.110689 13.7479 0.229421 14.8329L1.49774 25.7546C2.11552 31.1533 6.04019 35.6816 11.3997 37.1744C18.306 39.0981 25.4208 35.1957 27.2986 28.454L31.1222 14.7266ZM24.1736 27.5836C22.7674 32.6322 17.4213 35.5645 12.2493 34.1239C8.17115 32.9879 5.19034 29.5443 4.71843 25.4354L3.43434 14.3285L4.203 14.7727C4.87078 15.156 5.30447 15.8356 5.38317 16.5807L5.84809 20.8356L8.97315 21.7061L13.434 5.69074C13.553 5.26366 13.9902 5.02385 14.4277 5.14572C14.8652 5.26758 15.1155 5.69889 14.9965 6.12596L11.8102 17.5655L14.9353 18.4359L18.9713 3.94587C19.0902 3.51879 19.5275 3.27898 19.965 3.40084C20.4025 3.5227 20.6528 3.95401 20.5338 4.38109L16.4978 18.8712L19.6229 19.7416L23.0216 7.53944C23.1406 7.11236 23.5778 6.87255 24.0153 6.99441C24.4528 7.11628 24.7031 7.54759 24.5841 7.97466L21.1854 20.1768L24.3104 21.0473L26.4347 13.4209C26.5536 12.9938 26.9908 12.754 27.4283 12.8759C27.8659 12.9978 28.1161 13.4291 27.9972 13.8561L24.1736 27.5836Z" />
  </svg>
)

export const TrackIcon = () => (
  <svg
    className="icon track-icon nav-bar-svgs"
    data-type="menu-icons"
    data-name="Layer 2"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="#007B98"
  >
    <path
      d="M15.7285 3.88396C17.1629 2.44407 19.2609 2.41383 20.4224 3.57981C21.586 4.74798 21.5547 6.85922 20.1194 8.30009L17.6956 10.7333C17.4033 11.0268 17.4042 11.5017 17.6976 11.794C17.9911 12.0863 18.466 12.0854 18.7583 11.7919L21.1821 9.35869C23.0934 7.43998 23.3334 4.37665 21.4851 2.5212C19.6346 0.663551 16.5781 0.905664 14.6658 2.82536L9.81817 7.69182C7.90688 9.61053 7.66692 12.6739 9.51519 14.5293C9.80751 14.8228 10.2824 14.8237 10.5758 14.5314C10.8693 14.2391 10.8702 13.7642 10.5779 13.4707C9.41425 12.3026 9.44559 10.1913 10.8809 8.75042L15.7285 3.88396Z"
      fill="#007B98"
    />
    <path
      d="M14.4851 9.47074C14.1928 9.17728 13.7179 9.17636 13.4244 9.46868C13.131 9.76101 13.1301 10.2359 13.4224 10.5293C14.586 11.6975 14.5547 13.8087 13.1194 15.2496L8.27178 20.1161C6.83745 21.556 4.73937 21.5863 3.57791 20.4203C2.41424 19.2521 2.44559 17.1408 3.88089 15.6999L6.30473 13.2667C6.59706 12.9732 6.59614 12.4984 6.30268 12.206C6.00922 11.9137 5.53434 11.9146 5.24202 12.2081L2.81818 14.6413C0.906876 16.5601 0.666916 19.6234 2.51519 21.4789C4.36567 23.3365 7.42221 23.0944 9.33449 21.1747L14.1821 16.3082C16.0934 14.3895 16.3334 11.3262 14.4851 9.47074Z"
      fill="#007B98"
    />
  </svg>
)

export const ReportIcon = () => (
  <svg
    className="nav-bar-svgs"
    data-type="menu-icons"
    data-name="Layer 3"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 145.7 142.27"
    fill="#FFD70F"
  >
    <path
      className="cls-1"
      d="M150.48,142.34V45.73c0-8.8-6.12-16-13.65-16H122.29c-7.53,0-13.65,7.16-13.65,16v94H97.82V22c0-8.8-6.15-16-13.71-16H69.47c-7.56,0-13.71,7.16-13.71,16V139.74H47V73.4A13.66,13.66,0,0,0,33.34,59.75H18.8A13.66,13.66,0,0,0,5.15,73.4v70.23s0,.06,0,.1a3,3,0,0,0,0,.31,4.3,4.3,0,0,0,4.3,4.3h137.1a4.3,4.3,0,0,0,3.95-6ZM117.64,45.73c0-4.1,2.45-7,4.65-7h14.54c2.2,0,4.65,2.86,4.65,7v94H117.64ZM64.76,22c0-3.71,2.2-7,4.71-7H84.11c2.51,0,4.71,3.25,4.71,7V139.74H64.76Zm-46,46.72H33.34A4.66,4.66,0,0,1,38,73.4v66.34H14.15V73.4A4.65,4.65,0,0,1,18.8,68.75Z"
      transform="translate(-5.13 -6.07)"
    />
  </svg>
)

export const ConnectIcon = () => (
  <svg
    fill="#0fc3f0"
    data-type="menu-icons"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g id="connect">
      <g>
        <path
          d="M5.9,24c-1.6,0-3.1-0.6-4.2-1.7C0.6,21.2,0,19.7,0,18.1c0-1.6,0.6-3.1,1.7-4.2l3.8-3.8l2,2l2.8-2.8l1.4,1.4l-2.8,2.8
			l1.6,1.6l2.8-2.8l1.4,1.4l-2.8,2.8l2,2l-3.7,3.8C9,23.3,7.5,24,5.9,24z M5.5,12.9l-2.3,2.3C2.4,16,2,17,2,18s0.4,2,1.2,2.8
			c1.5,1.5,4.1,1.5,5.6,0l2.3-2.4L5.5,12.9z M18.5,13.9l-8.4-8.4l3.7-3.8C14.9,0.6,16.5,0,18,0c1.5,0,3,0.6,4.2,1.7
			C23.4,2.8,24,4.3,24,5.9s-0.6,3.1-1.7,4.2L18.5,13.9z M13,5.5l5.5,5.5l2.3-2.3C21.6,7.9,22,7,22,5.9c0-1-0.4-2-1.2-2.8
			c-1.5-1.5-4-1.5-5.6,0L13,5.5z"
        />
      </g>
    </g>
  </svg>
)

export const PlanIcon = ({ fillColor = '#e61969' }: { fillColor?: string }) => (
  <svg
    fill={fillColor}
    width="800px"
    height="800px"
    data-type="menu-icons"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path d="M21 5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5zM5 19V5h14l.002 14H5z" />
    <path d="M7 7h1.998v2H7zm4 0h6v2h-6zm-4 4h1.998v2H7zm4 0h6v2h-6zm-4 4h1.998v2H7zm4 0h6v2h-6z" />
  </svg>
)

export const ExplainIcon = () => (
  <svg
    className="icon explain nav-bar-svgs"
    data-type="menu-icons"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 150.98 93.5"
    fill="#E61969"
  >
    <title>nav-bar-icons</title>
    <path
      className="cls-1"
      d="M130.62,47.42a12.49,12.49,0,0,1-1.74-3.24A12.49,12.49,0,0,0,130.62,47.42Z"
      transform="translate(-2.23 -27.39)"
    />
    <path
      className="cls-3"
      d="M140.67,52.48a12,12,0,0,0,1.91-.15,12,12,0,0,1-1.91.15Z"
      transform="translate(-2.23 -27.39)"
    />
    <path
      className="cls-3"
      d="M153.18,40.9a12.78,12.78,0,0,1-.29,1.87A12.78,12.78,0,0,0,153.18,40.9Z"
      transform="translate(-2.23 -27.39)"
    />
    <path
      className="cls-3"
      d="M153.18,40.9q0-.48,0-1h0Q153.21,40.42,153.18,40.9Z"
      transform="translate(-2.23 -27.39)"
    />
    <path
      className="cls-3"
      d="M128.13,39.94c0,.39,0,.78.05,1.16,0-.38-.05-.77-.05-1.16Z"
      transform="translate(-2.23 -27.39)"
    />
    <path
      className="cls-3"
      d="M145.55,28.38a12.37,12.37,0,0,0-8.12-.55,12.37,12.37,0,0,1,8.12.55Z"
      transform="translate(-2.23 -27.39)"
    />
    <path
      className="cls-3"
      d="M147.68,29.53a13.12,13.12,0,0,1,1.86,1.54A13.12,13.12,0,0,0,147.68,29.53Z"
      transform="translate(-2.23 -27.39)"
    />
    <path
      className="cls-3"
      d="M134,29.31A12.46,12.46,0,0,1,136.87,28,12.46,12.46,0,0,0,134,29.31Z"
      transform="translate(-2.23 -27.39)"
    />
    <path
      className="cls-3"
      d="M145.55,28.38a12.46,12.46,0,0,1,2.13,1.15A12.46,12.46,0,0,0,145.55,28.38Z"
      transform="translate(-2.23 -27.39)"
    />
    <path
      className="cls-3"
      d="M152.65,36.21a12.42,12.42,0,0,0-3.11-5.14,13.12,13.12,0,0,0-1.86-1.54,12.43,12.43,0,0,0-10.25-1.7l-.56.16A12.46,12.46,0,0,0,134,29.31a12.12,12.12,0,0,0-1.81,1.37A13.55,13.55,0,0,0,131,32a12.51,12.51,0,0,0-2.3,4.25,12.38,12.38,0,0,0-.56,3.73c0,.39,0,.78.05,1.16,0,.15,0,.28.06.42s.06.47.1.71.07.35.11.52.09.35.14.53.11.4.18.6.07.2.11.3a12.49,12.49,0,0,0,1.74,3.24L119.34,63.26A32.83,32.83,0,0,0,67.12,76.12L52,66.54a12.53,12.53,0,1,0-21.83,5L17.3,92.09c-.41-.08-.82-.14-1.24-.19s-.85-.06-1.29-.06-.64,0-1,0a11.55,11.55,0,0,0-1.87.28q-.45.11-.9.24a13.92,13.92,0,0,0-2.25.95,13,13,0,0,0-2,1.35,13.09,13.09,0,0,0-2.42,2.67,12.41,12.41,0,0,0-2.14,7c0,.33,0,.65,0,1a11.55,11.55,0,0,0,.28,1.87c.07.3.15.6.24.89a12.61,12.61,0,0,0,2.3,4.25c.26.31.53.61.81.89a11.22,11.22,0,0,0,.89.81,12.44,12.44,0,0,0,4.25,2.3c.3.09.6.18.9.25a12.72,12.72,0,0,0,5.67,0c.3-.07.6-.16.89-.25a12.56,12.56,0,0,0,8.25-8.25c.09-.29.18-.59.25-.89a12.77,12.77,0,0,0,.28-1.87c0-.32,0-.64,0-1s0-.82-.06-1.22c0-.17-.05-.33-.07-.5s-.07-.46-.11-.69-.1-.42-.15-.63-.08-.33-.13-.5-.15-.48-.24-.71-.08-.24-.13-.36-.22-.52-.34-.77L26,98.76c-.14-.28-.29-.55-.45-.82l-.08-.14c-.18-.28-.36-.56-.56-.83l-.05-.06c-.21-.28-.43-.56-.67-.83h0L36.92,75.7a12.93,12.93,0,0,0,2.94.36,12.51,12.51,0,0,0,7.92-2.82l17.33,11A33.66,33.66,0,0,0,64.89,88a32.87,32.87,0,1,0,59.87-18.71L137.12,52c.29.09.58.16.87.22l.5.1.65.1.41,0a10.37,10.37,0,0,0,1.12.06h0a12,12,0,0,0,1.91-.15,12.31,12.31,0,0,0,1.82-.41,12.61,12.61,0,0,0,4.25-2.3,13.08,13.08,0,0,0,1.7-1.71,12.47,12.47,0,0,0,2.3-4.24q.14-.45.24-.9a12.78,12.78,0,0,0,.29-1.87q0-.48,0-1A12.38,12.38,0,0,0,152.65,36.21ZM14.77,109a4.59,4.59,0,0,1-2.17-8.65,4.55,4.55,0,0,1,2.17-.57,4.61,4.61,0,0,1,4.54,3.86,4.76,4.76,0,0,1,.07.75A4.6,4.6,0,0,1,14.77,109ZM39.86,68.13a4.62,4.62,0,0,1-4.61-4.62s0-.08,0-.12a4.61,4.61,0,1,1,4.6,4.74Zm53,5.28a4.92,4.92,0,1,1,9.84,0V86.69a4.92,4.92,0,1,1-9.84,0Zm4.92,34.87a5.65,5.65,0,1,1,5.64-5.64A5.65,5.65,0,0,1,97.76,108.28ZM142.8,44a4.53,4.53,0,0,1-2.13.55,4.62,4.62,0,0,1-4.61-4.61.88.88,0,0,1,0-.17A4.6,4.6,0,1,1,142.8,44Z"
      transform="translate(-2.23 -27.39)"
    />
    <path
      className="cls-3"
      d="M136.87,28l.56-.16Z"
      transform="translate(-2.23 -27.39)"
    />
    <path
      className="cls-1"
      d="M27.32,104.38h0c0,.33,0,.65,0,1C27.3,105,27.32,104.71,27.32,104.38Z"
      transform="translate(-2.23 -27.39)"
    />
    <path
      className="cls-1"
      d="M27.28,105.35a12.77,12.77,0,0,1-.28,1.87A12.77,12.77,0,0,0,27.28,105.35Z"
      transform="translate(-2.23 -27.39)"
    />
    <path
      className="cls-1"
      d="M2.55,107.22a11.55,11.55,0,0,1-.28-1.87A11.55,11.55,0,0,0,2.55,107.22Z"
      transform="translate(-2.23 -27.39)"
    />
    <path
      className="cls-1"
      d="M2.23,104.38c0,.33,0,.65,0,1,0-.32,0-.64,0-1Z"
      transform="translate(-2.23 -27.39)"
    />
    <path
      className="cls-1"
      d="M11.94,116.61a12.72,12.72,0,0,0,5.67,0,12.72,12.72,0,0,1-5.67,0Z"
      transform="translate(-2.23 -27.39)"
    />
    <path
      className="cls-3"
      d="M6.79,94.7a13.09,13.09,0,0,0-2.42,2.67A13.09,13.09,0,0,1,6.79,94.7Z"
      transform="translate(-2.23 -27.39)"
    />
    <path
      className="cls-3"
      d="M11.94,92.16a11.55,11.55,0,0,1,1.87-.28A11.55,11.55,0,0,0,11.94,92.16Z"
      transform="translate(-2.23 -27.39)"
    />
    <path
      className="cls-3"
      d="M14.77,91.84c-.32,0-.64,0-1,0,.32,0,.64,0,1,0Z"
      transform="translate(-2.23 -27.39)"
    />
  </svg>
)

export const SettingsIcon = () => (
  <svg
    className="nav-bar-svgs"
    data-type="menu-icons"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 126.35 123.81"
    fill="#9F9F9F"
  >
    <title>nav-bar-icons</title>
    <path
      className="cls-1"
      d="M84.7,141H71.41c-2,0-2.69,0-9.5-16.86L56.65,122c-14.33,6.5-16,6.5-16.59,6.5H39l-.93-.8-9.42-9.22c-1.43-1.42-1.93-1.92,5.44-18.57l-2.14-5.07c-17.3-6.2-17.3-6.92-17.3-9v-13c0-2,0-2.68,17.24-9.35L34,58.43C26.2,42,26.74,41.52,28.27,40.08L38.4,30.15l1.26,0c1.53,0,7.2,2.07,16.87,6.15l5.24-2.13C68.08,17.2,68.86,17.2,70.85,17.2H84.13c2,0,2.69,0,9.5,16.88L98.9,36.2c14.3-6.49,16-6.49,16.59-6.49h1.09l.94.79,9.41,9.19c1.43,1.45,1.92,1.94-5.44,18.6l2.15,5.1C141,69.56,141,70.28,141,72.33v13c0,2,0,2.7-17.27,9.37l-2.13,5.08c7.76,16.33,7.25,16.84,5.79,18.3l-10.2,10-1.26,0c-1.52,0-7.18-2.07-16.84-6.16l-5.27,2.13C87.45,141,86.73,141,84.7,141Zm-11.9-5.37H83.27c1.2-2.45,3.8-8.95,5.88-14.55l.42-1.11,9.54-3.85,1,.43c5.69,2.43,12.41,5.11,15,5.94l7.36-7.2c-.94-2.59-3.77-8.93-6.33-14.28l-.51-1.09,3.94-9.42,1.08-.42c5.74-2.21,12.39-4.94,14.88-6.18V73.8c-2.52-1.19-9.14-3.71-14.86-5.73l-1.11-.4-4-9.43.48-1.07c2.44-5.51,5.16-12,6-14.64l-7.38-7.21c-2.38.83-9.05,3.69-14.68,6.26l-1,.48-9.54-3.85-.42-1.06C86.81,31.52,84,25,82.75,22.58H72.28c-1.21,2.45-3.8,9-5.87,14.54L66,38.23l-9.51,3.86-1-.44c-5.7-2.42-12.43-5.1-15.06-5.92l-7.35,7.2c.92,2.59,3.77,8.93,6.32,14.28l.52,1.09-4,9.41-1.07.41C29.12,70.33,22.48,73.06,20,74.3V84.43c2.52,1.18,9.14,3.71,14.84,5.74l1.11.41,4,9.4L39.44,101c-2.44,5.51-5.16,12-6,14.62l7.4,7.24c2.37-.84,9-3.7,14.67-6.27l1.05-.48L66.05,120l.43,1.06C68.74,126.71,71.53,133.22,72.8,135.64Zm5-34.86A21.67,21.67,0,1,1,99.85,79.1,21.92,21.92,0,0,1,77.78,100.78Zm0-37.95A16.29,16.29,0,1,0,94.47,79.11,16.51,16.51,0,0,0,77.78,62.83Z"
      transform="translate(-14.61 -17.2)"
    />
  </svg>
)
